module.exports = __webpack_public_path__ + "images/category_lp/watch_samples/sec02_2_sp_c30970e026303987b3bcbbafb9e2d097.png";